import { Grid, Typography } from '@mui/material';
import { useForm } from "react-hook-form";
import { ControlledInput } from '../../components/forms/input/ControlledInput';
import { endpoints } from '../../api/endpoints';
import { ModalFooter } from '../../components/modal/ModalFooter';
import AddEditModal from '../../components/modal/Modal';
import { useContext, useEffect, useState } from 'react';
import { useCrudForm } from '../../api/useCrudForm';
import CustomSelect from '../../components/forms/select/CustomSelect';
import { ControlledTextArea } from '../../components/forms/input/ControlledTextArea';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { AppContext } from "../../contexts/AppContext";

export default function AddEditLockerModal({ refetchData, open, setOpen, setSelectedItem, selectedItem, showApproved, setShowApproved, setSkip, setTake }: { refetchData: any, open: boolean, setOpen: (value: boolean) => void, selectedItem: any, setSelectedItem: (value: any) => void, showApproved: string, setShowApproved: (value: string) => void, setSkip: any, setTake: any }) {
    return (
        <AddEditModal title={selectedItem ? 'Edit Locker' : 'Add New Locker'} setOpen={setOpen} setSelectedItem={setSelectedItem} open={open}>
            <GeneralInfo refetchData={refetchData} selectedItem={selectedItem} setSelectedItem={setSelectedItem} setOpen={setOpen} showApproved={showApproved} setShowApproved={setShowApproved} setSkip={setSkip} setTake={setTake} />
        </AddEditModal>
    );
}

const GeneralInfo = ({ refetchData, setSelectedItem, selectedItem, setOpen, showApproved, setShowApproved, setSkip, setTake }: { refetchData: any, setSelectedItem: (value: any) => void, selectedItem: any, setOpen: (value: boolean) => void, showApproved: string, setShowApproved: (value: string) => void, setSkip: any, setTake: any }) => {
    const { handleSubmit, control, formState: { errors, }, watch, setValue } = useForm(
        {
            resolver: yupResolver(LockerSchema),
            defaultValues: selectedItem ? {
                ...selectedItem,
                createdDate: selectedItem.createdDate.slice(0, 10)
            } : {
                lockerNumber: "",
                lockerTypeId: 0,
                branchId: 0,
                locationId: 0,
                vendorId: 0,
                binNumber: '',
                keyNumber: '',
                agreementNumber: '',
                rentChargeFrequency: '',
                description: "",
                createdDate: new Date().toISOString().slice(0, 10)
            }
        }
    )
    const [lockerType, setLockerType] = useState()
    const [branchList, setBranchList] = useState()
    const [lockerLocation, setlockerLocation] = useState()
    const [lockerVendor, setLockerVendor] = useState()
    const [rentFrequency, setRentFrequency] = useState()
    const [lockerStatus, setLockerStatus] = useState()
    const { user } = useContext(AppContext)
    const watchBranch: any = watch("branchId")
    const watchLocation: any = watch("locationId")

    const { get } = useCrudForm();

    const getLockerLocation = () => {
        get({
            endpoints: endpoints.common.getLocations(watchBranch),
            onSuccess: (data: any) => {
                setlockerLocation(data.data)
                setValue('locationId', watchLocation ?? 0)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }

    useEffect(() => {
        if (watchBranch) {
            getLockerLocation()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [watchBranch])

    useEffect(() => {
        get({
            endpoints: endpoints.common.getLockerTypes,
            onSuccess: (data: any) => {
                setLockerType(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })

        get({
            endpoints: endpoints.common.getVendors,
            onSuccess: (data: any) => {
                setLockerVendor(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })

        get({
            endpoints: endpoints.common.getRentChargeFrequency,
            onSuccess: (data: any) => {
                setRentFrequency(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })

        get({
            endpoints: endpoints.common.getLockerStatusForLockerUpdate,
            onSuccess: (data: any) => {
                setLockerStatus(data.data)
            },
            onError: (error: any) => {
                console.log(error)
            }
        })

        get({
            endpoints: endpoints.common.getBranches,
            onSuccess: (data: any) => {
                setBranchList(data.data)
                if (!user?.IsSuperAdmin) {
                    setValue('branchId', parseInt(user?.branchId))
                }
            },
            onError: (error: any) => {
                console.log(error)
            }
        })
    }, [])

    const cancelMessage = 'Cancel current unsaved changes and go back to Locker list?'

    const onSuccess = (values: any, id?: number) => {
        setSkip(0)
        setTake(10)
        if (values.id) {
            setShowApproved('false')
            refetchData({ isMainTable: false })
            setOpen(false);
            setSelectedItem(null)
        } else {
            setShowApproved('false')
            refetchData({ isMainTable: false })
            setOpen(false);
            setSelectedItem(null)
        }
    }

    const onError = (error: any) => {
        toast.error(error)
        setOpen(false);
        setSelectedItem(null)
    }

    const handleClose = () => {
        setOpen(false);
        setSelectedItem(null)
    };

    return (
        <>
            <Typography component={'p'} mt={2} mb={2}>General Information</Typography>
            <Grid container spacing={2}>
                <Grid item xs={6} >
                    <ControlledInput name="lockerNumber" control={control} errors={errors} label="Locker Number" disabled={selectedItem ? true : false} />
                </Grid>
                <Grid item xs={6} >
                    <CustomSelect
                        label="Locker Type"
                        name="lockerTypeId"
                        errors={errors?.lockerTypeId?.message}
                        control={control}
                        values={lockerType ?? []}
                        size={12}
                        setValue={setValue}
                        labelName="lockerType"
                        disabled={selectedItem ? true : false}
                    />
                </Grid>
                {
                    user?.IsSuperAdmin &&
                    <Grid item xs={6} >
                        <CustomSelect
                            label="Branch"
                            name="branchId"
                            errors={errors?.branchId?.message}
                            control={control}
                            values={branchList ?? []}
                            size={12}
                            setValue={setValue}
                            labelName="branchName"
                            disabled={selectedItem ? true : false}
                        />
                    </Grid>
                }
                <Grid item xs={6} >
                    <CustomSelect
                        label="Locker Location"
                        name="locationId"
                        errors={errors?.locationId?.message}
                        control={control}
                        values={lockerLocation ?? []}
                        size={12}
                        setValue={setValue}
                        labelName="locationName"
                        disabled={selectedItem ? true : false}
                    />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput name="binNumber" control={control} errors={errors} label="Bin Number" disabled={selectedItem ? true : false} />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput name="keyNumber" control={control} errors={errors} label="Key Number" disabled={selectedItem ? true : false} />
                </Grid>
                <Grid item xs={6} >
                    <ControlledInput name="agreementNumber" control={control} errors={errors} label="Agreement Number" disabled={selectedItem ? true : false} />
                </Grid>
                <Grid item xs={6} >
                    <CustomSelect
                        label="Vendor"
                        name="vendorId"
                        errors={errors?.vendorId?.message}
                        control={control}
                        values={lockerVendor ?? []}
                        size={12}
                        setValue={setValue}
                        labelName="lockerVendor"
                        disabled={selectedItem ? true : false}
                    />
                </Grid>
                <Grid item xs={6} >
                    <CustomSelect
                        label="Rent Charge Frequency"
                        name="rentChargeFrequency"
                        errors={errors?.rentChargeFrequency?.message}
                        control={control}
                        values={rentFrequency ?? []}
                        size={12}
                        setValue={setValue}
                        isEnum={true}
                        labelName="rentFrequency"
                        disabled={selectedItem ? true : false}
                    />
                </Grid>
                {
                    selectedItem && (selectedItem?.status === 0 || selectedItem?.status === 4 || selectedItem?.status === 5 || selectedItem?.status === 6) ?
                        <Grid item xs={6} >
                            <CustomSelect
                                label="Status"
                                name="status"
                                errors={errors?.status?.message}
                                control={control}
                                values={lockerStatus ?? []}
                                size={12}
                                setValue={setValue}
                                isEnum={true}
                                labelName="lockerStatus"
                            />
                        </Grid> : null
                }
                <Grid item xs={12} >
                    <ControlledTextArea name="description" control={control} errors={errors} label="Description" />
                </Grid>
            </Grid>
            <ModalFooter endpoint={endpoints.locker.add} editEndpoint={endpoints.locker.edit} onSuccess={onSuccess} handleSubmit={handleSubmit} handleModalClose={handleClose} selectedItem={selectedItem} cancelMessage={cancelMessage} onError={onError} />
        </>
    )
}

export const LockerSchema = Yup.object().shape({
    lockerTypeId: Yup.number().required('Required').notOneOf([0], 'Required'),
    locationId: Yup.number().required('Required').notOneOf([0], 'Required'),
    lockerNumber: Yup.string().required("Locker Number Required"),
    vendorId: Yup.number().required('Required').notOneOf([0], 'Required'),
    binNumber: Yup.string().required('Required'),
    keyNumber: Yup.string().required('Required'),
    agreementNumber: Yup.string().required('Required'),
    rentChargeFrequency: Yup.number().required('Required').typeError('Required'),
    description: Yup.string(),
});